import "./resizeObserverPatch"; // must precede Sentry so it picks up the patched observer
import "./instrument"; // Sentry — must be first import
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
